var DownloadInvoiceError;
(function(DownloadInvoiceError) {
    DownloadInvoiceError["GENERIC_ERROR"] = "GENERIC_ERROR";
    DownloadInvoiceError["INVALID_CUSTOMER_INFO"] = "INVALID_CUSTOMER_INFO";
    DownloadInvoiceError["INVALID_ORDER_STATUS"] = "INVALID_ORDER_STATUS";
    DownloadInvoiceError["ORDER_NOT_INVOICED"] = 'ORDER_NOT_INVOICED_YET';
    DownloadInvoiceError["ORDER_NOT_BELONG_TO_CUSTOMER"] = "ORDER_NOT_BELONG_TO_CUSTOMER";
})(DownloadInvoiceError || (DownloadInvoiceError = {}));

export { DownloadInvoiceError };
//# sourceMappingURL=types.js.map
